// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__QI-58","moreInfo":"TopMenu_moreInfo__I3NMH","logo":"TopMenu_logo__Ru415","menuTrigger":"TopMenu_menuTrigger__UMQwG","closed":"TopMenu_closed__Azvbe"};